import { render, staticRenderFns } from "./DiagnosisResult.vue?vue&type=template&id=f8d4514e&scoped=true&"
import script from "./DiagnosisResult.vue?vue&type=script&lang=js&"
export * from "./DiagnosisResult.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisResult.vue?vue&type=style&index=0&id=f8d4514e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d4514e",
  null
  
)

export default component.exports